import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { PLANTILLAS_CABECERA_PIE_MAIN } from 'constants/codigosTransacciones'

import MainPage from './main'

export default function CompaniasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${PLANTILLAS_CABECERA_PIE_MAIN}`} component={MainPage} />
      </Switch>
    </Suspense>
  )
}
